import React, { memo } from 'react';
import Col from 'react-bootstrap/Col';
// use object default values over defaultProps when using the component in the wrapper and passing the same props directly
// example <FilterTemplate sm={sm} inColumn={inColumn} /> if the variable sm and inColumn are undefined 
// the value will remain undefined even you have defaultProps = { sm: 4, inColumn: true }
// which is a problem with react@17.0.2
// there are work around to this if you also set a defaultProps on the wrapper
const FilterTemplate = /*#__PURE__*/memo(({
  md = 4,
  sm = 6,
  lg,
  xl = 3,
  inColumn = true,
  children
}) => {
  return inColumn ? /*#__PURE__*/React.createElement(Col, {
    md: md,
    sm: sm,
    lg: lg,
    xl: xl
  }, children) : /*#__PURE__*/React.createElement(React.Fragment, null, children);
});
export default FilterTemplate;